import { useMutation } from '@apollo/client';
import clientAccount from 'apps/accounts/app/utils/clientAccount';
import {
  ArchiveSignalClassByTimeStamp,
  ArchiveSignalClassByTimeStampVariables,
} from 'apps/events/app/signal/types/ArchiveSignalClassByTimeStamp';
import useNotifier from 'hooks/useNotifier';
import { handleGQLErrors } from 'utils/gqlErrors';
import { archiveSignalClassByTimeStampMutation } from '../mutations';

const useArchiveSignal = ({ onComplete }: { onComplete?: () => void }) => {
  const notify = useNotifier();
  const [mutation, mutationOpts] = useMutation<
    ArchiveSignalClassByTimeStamp,
    ArchiveSignalClassByTimeStampVariables
  >(archiveSignalClassByTimeStampMutation, {
    client: clientAccount,
    onCompleted: (data) => {
      if (onComplete) {
        onComplete();
      }
      notify({ text: 'Success', status: 'success' });
    },
    onError: (err) => {
      handleGQLErrors(notify, err);
    },
  });

  return {
    mutation,
    mutationOpts,
  };
};

export default useArchiveSignal;
